import { Trans } from "@lingui/react/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import { Outlet } from "react-router";
import styles from "./RegisterPatient.module.scss";

export const RegisterPatient = () => {
  return (
    <section className={styles.registerPatient}>
      <Heading level="h1">
        <Trans>Registrera patient</Trans>
      </Heading>
      <Outlet />
    </section>
  );
};
